module.exports = __webpack_public_path__ + "img/category.4083f419.jpg";